import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Plus, CheckSquare, List, LayoutDashboard, ShoppingBag } from 'lucide-react';

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/approvals-dashboard', icon: CheckSquare, label: 'Approvals' },
    { path: '/wishlist', icon: ShoppingBag, label: 'Wishlist' },
    { path: '/my-rsvps', icon: List, label: 'My RSVPs' },
    { path: '/profile', icon: LayoutDashboard, label: 'Dashboard' }
  ];

  return (
    <>
      {/* Bottom Navigation Bar - Contribo Theme */}
      <nav className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-contribo-navy to-contribo-gold border-t-2 border-contribo-gold z-50 safe-area-bottom shadow-2xl">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`flex flex-col items-center justify-center flex-1 h-full transition-all touch-target relative ${
                  active 
                    ? 'text-white scale-110' 
                    : 'text-gray-200 hover:text-white active:text-contribo-gold'
                }`}
                aria-label={item.label}
              >
                <Icon className={`h-6 w-6 ${active ? 'stroke-[3]' : 'stroke-2'}`} />
                <span className={`text-[10px] mt-1 ${active ? 'font-bold' : 'font-medium'}`}>
                  {item.label}
                </span>
                {active && (
                  <div className="absolute top-0 w-12 h-1 bg-contribo-gold rounded-b-full shadow-lg" />
                )}
              </button>
            );
          })}
        </div>
      </nav>
      
      {/* Bottom padding to prevent content from being hidden behind nav */}
      <div className="h-16" />
    </>
  );
};

export default BottomNavigation;
